import React, { useState } from "react";
import { auth } from "../firebaseConfig";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { Container, Form, Button, Card, Alert } from "react-bootstrap";

const SignupPage = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const handleSignup = async (e) => {
        e.preventDefault();
        try {
            await createUserWithEmailAndPassword(auth, email, password);
            navigate("/"); // Redirect to home page after signup
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <Container className="d-flex justify-content-center align-items-center vh-100">
            <Card className="p-4 shadow-sm" style={{ width: "400px" }}>
                <Card.Body>
                    <h2 className="text-center mb-4">Sign Up</h2>

                    {error && <Alert variant="danger">{error}</Alert>}

                    <Form onSubmit={handleSignup}>
                        <Form.Group className="mb-3">
                            <Form.Label>Email Address</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="Enter email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Enter password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </Form.Group>

                        <Button variant="primary" type="submit" className="w-100 mb-2">
                            Sign Up
                        </Button>
                    </Form>

                    <div className="text-center mt-3">
                        Already have an account? <a href="/login">Login</a>
                    </div>
                    <hr className="my-4" style={{ opacity: 0.1 }} />
                    <div className="text-center d-flex justify-content-center gap-3">
                        <a href="/privacy" style={{ fontSize: '0.75rem', color: 'rgba(0,0,0,0.5)', textDecoration: 'none' }}>Privacy Policy</a>
                        <a href="/terms" style={{ fontSize: '0.75rem', color: 'rgba(0,0,0,0.5)', textDecoration: 'none' }}>Terms of Service</a>
                    </div>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default SignupPage;